@if (checksDetail && evaluationData) {
    <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.REQUIREMENTS' | translate">
        <app-checks [detail]="checksDetail" [checks]="[CHECK.FINANCIAL_STATE]" />
    </tec-tile>

    @if (!isWorkLifeType) {
        <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.COMPARE_INFO' | translate">
            @if (isBankScoringMatchData) {
                <tec-item
                    [classes]="['item--outline']"
                    [tagImage]="{ icon: 'icon-resize-viewport', status: 'simple' }"
                    [tagIcon]="getTagIconItem()"
                    [title]="'PROCESSES.DETAIL.EVALUATION_MATCH_DATA' | translate"
                    [clickeable]="false"
                >
                    <tec-link (click)="openBankDetailsModal($event)">
                        {{ 'GENERAL.SHOW_DETAILS' | translate }}
                    </tec-link>
                    <tec-list-detail>
                        <span>{{ maskIban(evaluatedIban) }}</span>
                    </tec-list-detail>
                </tec-item>
                <app-operation-detail-tabs-checks-financial-evaluation-bank-modal
                    [isVisible]="isBankDetailsModalVisible"
                    [evaluatedIban]="evaluatedIban"
                    [registryIban]="registryIban"
                    (closeEvent)="closeBankDetailsModal()"
                />
            } @else if (evaluationData.evaluation === EVALUATION_TYPE.MATCH_DATA) {
                @if (isIrpfMatchData) {
                    <tec-item
                        [classes]="['item--outline']"
                        [tagImage]="{ icon: 'icon-resize-viewport', status: 'simple' }"
                        [tagIcon]="getTagIconItem()"
                        [title]="'PROCESSES.DETAIL.EVALUATION_MATCH_DATA' | translate"
                        [clickeable]="false"
                    >
                        <tec-link (click)="openIrpfDetailsModal($event)">
                            {{ 'GENERAL.SHOW_DETAILS' | translate }}
                        </tec-link>
                        <tec-list-detail>
                            <span>{{ 'FINANCIAL_EVALUATION.IRPF' | translate }}</span>
                        </tec-list-detail>
                    </tec-item>
                    <app-operation-detail-tabs-checks-financial-evaluation-irpf-modal
                        [isVisible]="isIrpfDetailsModalVisible"
                        [status]="evaluationData.state"
                        [detailsPayload]="irpfDetailsPayload"
                        (closeEvent)="closeIrpfDetailsModal()"
                    />
                } @else {
                    <app-checks [detail]="checksDetail" [checks]="[CHECK.EVALUATION_MATCH_DATA]" />
                }
            } @else {
                <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
            }
        </tec-tile>
    }
} @else {
    <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}
